import React from "react";

// Diagonal corner-ribbon banner for PRE-ORDER swag — a gold/amber sash rotated -45° across the
// top-left corner of a card. Must sit inside a `position: relative; overflow: hidden` container
// (both the listing-card image box and the product-page gallery are); the container clips the band
// ends flush to the two card edges, giving the wrapped-ribbon look. `size`: "sm" for grid cards,
// "md" for the product detail image.
export function PreorderRibbon({ size = "md", label = "Pre-order", testid }) {
  const sm = size === "sm";
  return (
    <div
      data-testid={testid}
      aria-label={`${label} item`}
      className="pointer-events-none absolute font-mono font-bold uppercase text-center select-none"
      style={{
        top: sm ? 16 : 24,
        left: sm ? -44 : -52,
        width: sm ? 150 : 184,
        padding: sm ? "4px 0" : "6px 0",
        transform: "rotate(-45deg)",
        transformOrigin: "center",
        background: "linear-gradient(180deg, #ECC06A 0%, #D3A24E 45%, #B9852E 100%)",
        color: "#241700",
        fontSize: sm ? "9px" : "10.5px",
        letterSpacing: "0.16em",
        lineHeight: 1.1,
        boxShadow: "0 7px 16px -5px rgba(0,0,0,0.75), 0 1px 0 rgba(0,0,0,0.3)",
        borderTop: "1px solid rgba(255,255,255,0.45)",
        borderBottom: "1px solid rgba(0,0,0,0.3)",
        textShadow: "0 1px 0 rgba(255,255,255,0.25)",
        zIndex: 20,
      }}
    >
      {label}
    </div>
  );
}
